import React from "react";
import "./search-input.component.scss";
import { Input } from "antd";

export default function SearchInputComponent(props) {
  const { className, onChange, suffix = null, maxLength = 100, placeholder = "", isInstore , pleaseEnterDiscountCode = "" } = props;
  return (
    <>
      { isInstore && <div className="title-discount-code">{pleaseEnterDiscountCode}</div> }
      <Input
        className={`search-input ${className}`}
        suffix={suffix}
        maxLength={maxLength}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e)}
      />
    </>
  );
}
